import React, { useState, useEffect } from 'react'

import { Row, Col, FormGroup, Label, Input, Switch } from 'twyne-new.ui';

import InfoTip from '@Components/InfoTip';
import TwyneURL from 'components/form/TwyneURL';

const IfficientForm = ({ data, onChange, disabled }) => {
  const [urlChangeFlag, setUrlChangeFlag] = useState('');

  useEffect(() => {
    setUrlChangeFlag(data.url);
  }, [disabled, data.pubid]);

  return (
    <Row>
      <Col size="4">
        <FormGroup>
          <Label>Twyne Client</Label>
          <TwyneURL key={urlChangeFlag} value={data.url || ''} required onChange={twyurl => onChange('url', twyurl)} disabled={disabled} />
        </FormGroup>
      </Col>
      <Col size="2">
        <FormGroup>
          <Label>Pub ID</Label>
          <Input type="text" value={data.pubid || ''}
            onChange={e => onChange('pubid', e.target.value)} disabled={disabled}
          />
        </FormGroup>
      </Col>
      <Col size="2">
        <FormGroup>
          <Label>Source ID</Label>
          <Input type="text" value={data.srcid || ''}
            onChange={e => onChange('srcid', e.target.value)} disabled={disabled}
          />
        </FormGroup>
      </Col>
      <Col size="2">
        <FormGroup>
          <Label>
            Reward Mode
            <InfoTip>
              The reward mode needs to enable hide hosted submit to work properly.
            </InfoTip>
          </Label>
          <Switch
            onChange={e => onChange('reward', e.target.checked)}
            checked={data.reward || false}
            disabled={disabled}
          />
        </FormGroup>
      </Col>
      <Col size="2">
        <FormGroup>
          <Label>Suppress Redirect</Label>
          <Switch
            onChange={e => onChange('suppressredirect', e.target.checked)}
            checked={data.suppressredirect || false}
            disabled={disabled}
          />
        </FormGroup>
      </Col>
      <Col size="2">
        <FormGroup>
          <Label>Test Mode</Label>
          <Switch
            onChange={e => onChange('istest', e.target.checked)}
            checked={data.istest || false}
            disabled={disabled}
          />
        </FormGroup>
      </Col>
    </Row>
  );
}

export default IfficientForm;
